import { createRouter, createWebHistory } from "vue-router";
import LoginView from "@/views/LoginView";
import App from "@/App.vue";
import { inject } from "vue";
import AdminTplView from "@/views/AdminTplView.vue";

const routes = [
  {
    path: "/",
    name: "首页",
    component: App,
    redirect: "/login",
  },

  //404页面捕获
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    component: () => import("@/views/error/404View"),
  },

  {
    path: "/login",
    name: "登入",
    component: LoginView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },

  {
    path: "/admin",
    name: "后台管理",
    component: AdminTplView,
    redirect: "/home",
    children: [
      {
        path: "/home",
        component: () => import("../views/HomeView.vue"),
      },
      {
        path: "/user",
        name: "用户管理",
        component: () => import("@/views/pt/UserView.vue"),
      },
      {
        path: "/goods",
        name: "全局商品管理",
        component: () => import("@/views/pt/GoodsView.vue"),
      },
      {
        path: "/goodsClassification",
        name: "全局商品分类",
        component: () => import("@/views/pt/GoodsClassificationView.vue"),
      },
      {
        path: "/enterpriseAccount",
        name: "企业账户管理",
        component: () => import("@/views/pt/EnterpriseAccountView.vue"),
      },
      {
        path: "/area",
        name: "行政区域",
        component: () => import("@/views/pt/AreaView.vue"),
      },
      {
        path: "/module",
        name: "系统模块",
        component: () => import("@/views/pt/ModuleView.vue"),
      },
      {
        path: "/costItem",
        name: "费用项目",
        component: () => import("@/views/pt/CostItemView.vue"),
      },
      {
        path: "/userModulePower",
        name: "用户模块权限管理",
        component: () => import("@/views/pt/UserModulePowerView.vue"),
      },
      {
        path: "/setting",
        name: "系统参数设置",
        component: () => import("@/views/pt/SettingView.vue"),
      },
      {
        path: "/officialAccountSetting",
        name: "公众号接口",
        component: () => import("@/views/api3/OfficialAccountSettingView.vue"),
      },
      {
        path: "/smsSetting",
        name: "手机短信接口",
        component: () => import("@/views/api3/SmsSettingView.vue"),
      },

      {
        path: "/enterpriseCenter",
        name: "企业管理中心",
        component: () => import("@/views/ep/EnterpriseCenterView.vue"),
      },
      {
        path: "/enterpriseGoods",
        name: "企业商品库",
        component: () => import("@/views/ep/EnterpriseGoodsView.vue"),
      },
      {
        path: "/enterpriseGoodsPriceControl",
        name: "企业商品控价",
        component: () =>
          import("@/views/ep/EnterpriseGoodsPriceControlView.vue"),
      },
      {
        path: "/siteGoods",
        name: "站点商品管理",
        component: () => import("@/views/sm/SiteGoodsView"),
      },
      {
        path: "/stockInput",
        name: "入库管理",
        component: () => import("@/views/st/StockInputView.vue"),
      },
      {
        path: "/stockQuery",
        name: "库存查询",
        component: () => import("@/views/st/StockQueryView.vue"),
      },
      {
        path: "/stockMoneyDetail",
        name: "库存资金明细",
        component: () => import("@/views/st/StockMoneyDetailView.vue"),
      },
      {
        path: "/stockWarning",
        name: "库存预警设置",
        component: () => import("@/views/st/StockWarningView.vue"),
      },
      {
        path: "/siteCenter",
        name: "站点管理中心",
        component: () => import("@/views/sm/SiteCenterView.vue"),
      },
      {
        path: "/siteMemberClassification",
        name: "站点会员分类",
        component: () => import("@/views/sm/SiteMemberClassificationView.vue"),
      },
      {
        path: "/siteGoodsMemberPrice",
        name: "站点商品会员价",
        component: () => import("@/views/sm/SiteGoodsMemberPriceView.vue"),
      },
      {
        path: "/siteMember",
        name: "站点会员",
        component: () => import("@/views/sm/SiteMemberView.vue"),
      },
      {
        path: "/siteGoodsMemberExclusivePrice",
        name: "站点商品会员专享价",
        component: () =>
          import("@/views/sm/SiteGoodsMemberExclusivePriceView.vue"),
      },
      {
        path: "/siteSaleEvent",
        name: "促销活动",
        component: () => import("@/views/sm/SiteSaleEventView.vue"),
      },
      {
        path: "/siteCoupon",
        name: "站点优惠券",
        component: () => import("@/views/sm/SiteCouponView.vue"),
      },
      {
        path: "/siteUnpayOrder",
        name: "站点待付款订单",
        component: () => import("@/views/sa/SiteUnpayOrderView.vue"),
      },
      {
        path: "/siteOrderAwaitingShipment",
        name: "站点订单出库",
        component: () => import("@/views/sa/SiteOrderAwaitingShipment.vue"),
      },
      {
        path: "/pointOfSale",
        name: "收银",
        component: () => import("@/views/sa/PointOfSaleView.vue"),
      },
      {
        path: "/openOrder",
        name: "批发系统开单",
        component: () => import("@/views/sa/OpenOrderView.vue"),
      },
      {
        path: "/financeBookkeeping",
        name: "费用记账",
        component: () => import("@/views/fi/FinanceBookkeepingView.vue"),
      },
      {
        path: "/financeDeposit",
        name: "押金管理",
        component: () => import("@/views/fi/FinanceDepositView.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.name ? to.name : inject("appname");
  next();
});

export default router;
